import Vue from 'vue';
import VCA from '@vue/composition-api';
import { uploadFile } from '@/api/project.js';
Vue.use(VCA);

import './index.scss';
import 'minimce/dist/style.css';
import MiniMCE from 'minimce';


import 'tinymce/themes/silver';//主题
import 'tinymce/icons/default';//图标
// 浅色模式
import 'tinymce/skins/ui/oxide/skin.min.css'; // 皮肤
import contentCSS from '!!raw-loader!tinymce/skins/content/default/content.min.css';
import contentUICSS from '!!raw-loader!tinymce/skins/ui/oxide/content.min.css';
// 深色模式
// import 'tinymce/skins/ui/oxide-dark/skin.min.css' // 皮肤
// import contentCSS from '!!raw-loader!tinymce/skins/content/dark/content.min.css'
// import contentUICSS from '!!raw-loader!tinymce/skins/ui/oxide-dark/content.min.css'


const contentCustomCSS = `
.mce-content-body {
	line-height: 1;
	overflow: auto;
}
p {
	margin-block-end: 0;
	margin-block-start: 0;
}
div {
	max-width: 100%;
}
img {
	max-width: 100%;
	height: auto !important;
	vertical-align: middle;
}
body {
	font-family: 微软雅黑, Arial, sans-serif;
	font-size: 16px;
}
`;

// 自定义插件（非必须）
import InsertWord from './plugins/InsertWord/index';
import InsertImage from './plugins/InsertImage/index';

export default function () {
	Vue.use(MiniMCE, {
		options: {
			language: 'zh_CN',
			content_style: [contentCSS, contentUICSS, contentCustomCSS].join('\n'),
			// menubar: 'file edit format insert view tools table',
			menubar: false,
			menu: {
				insert: {
					title: '插入',
					items: 'localimage docx | image link media template codesample inserttable | charmap emoticons hr | pagebreak nonbreaking anchor toc | insertdatetime',
				},
				file: { title: '文件', items: 'preview' },
			},
			toolbar: 'undo redo bold italic underline strikethrough removeformat preview fullscreen fontsize blocks lineheight table forecolor backcolor alignleft aligncenter alignright alignjustify outdent indent bullist numlist image media link unlink charmap',// fontfamily
			font_size_formats: '6px 8px 10px 12px 14px 16px 18px 24px 36px',
			// font_family_formats: `
			// 					微软雅黑=Microsoft YaHei;
			// 					仿宋=仿宋;
			// 					宋体=宋体;
			// 					黑体=黑体;
			// 					`,
			height: 650,
			setup (editor) {
				const insertImage = InsertImage({ editor });
				editor.ui.registry.addMenuItem('localimage', {
					text: '本地图片',
					icon: 'image',
					onAction: () => {
						insertImage.$children[0].open();
					},
				});

				const insertWord = InsertWord({ editor });
				editor.ui.registry.addMenuItem('docx', {
					text: 'Word 文档',
					icon: 'new-document',
					onAction: () => {
						insertWord.$children[0].open();
					},
				});
				editor.on('blur', function () {
					const newContent = editor.getContent() + ' ';
					editor.setContent(newContent);
				});
				editor.on('init', function (e) {
					console.log(editor.getParam('toolbar'));
				});
			},
			images_upload_handler: (blobInfo, progress) =>
				new Promise((resolve, reject) => {
					const loading = Vue.prototype.$loading();
					const blob = blobInfo.blob();
					const file = new File([blob], blobInfo.filename(), { type: blob.type });
					let param = new FormData(); // 创建form对象
					param.append('file', file); //对应后台接收图片名
					uploadFile(param)
						.then((res) => {
							if (typeof res.data.url === 'string') {
								resolve(res.data.url);
							} else {
								reject(res.msg);
								return;
							}
						})
						.catch(() => {
							reject('上传出错，服务器开小差了呢');
							return;
						})
						.finally(() => {
							loading.close();
						});
				}),
		},
	});
}
